import { render, staticRenderFns } from "./VaimoRedirectModal.vue?vue&type=template&id=7ddd7f2a&scoped=true&"
import script from "./VaimoRedirectModal.vue?vue&type=script&lang=ts&"
export * from "./VaimoRedirectModal.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoRedirectModal.vue?vue&type=style&index=0&id=7ddd7f2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddd7f2a",
  null
  
)

export default component.exports